import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-expand-collapse',
  templateUrl: './expand-collapse.component.html',
  styleUrls: ['./expand-collapse.component.css']
})
export class ExpandCollapseComponent implements OnInit {
  @Output() expand = new EventEmitter<any>();
  isExpand: Boolean = false;
  constructor() { }

  ngOnInit(): void { 
  }

  onClick(event: string) {
    this.isExpand = !this.isExpand;
    this.expand.emit(event);
    window.dispatchEvent(new Event('resize')); 
  }
}
